// Define a convenience method and use it like
// ready(() => {...});
var ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};

/*
 * HISTORY STATE
 * Check if window.history is supported
 */
function historyState() {
  return window.history && window.history.replaceState;
};


/*
 * FORMAT MONEY
 * Formats the passed value as money with currency symbol.
 * Referenced from https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
 */
var Shopify = Shopify || {};

Shopify.moneyFormat = window.Shopify.shop.money_format || "{{amount}}"; 
Shopify.formatMoney = function(cents, format) {
  if (typeof cents === 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.moneyFormat;

  function defaultOption(opt, def) {
    return (typeof opt === 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  var match = formatString.match(placeholderRegex);
  var placeholder = match ? match[1] : null;

  switch (placeholder) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2); // Safe fallback
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/*
 * GET URL PARAMETER
 * Checks for url parameter called `name`.
 */
Shopify.getParam = function(name) {
  if ('URLSearchParams' in window) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  } else {
    // Polyfill for IE11
    var params = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (params == null) {
      return null;
    } else {
      return decodeURI(params[1]) || 0;
    }
  }
}

/*
 * Calculate Aspect Ratio
 * Calculates the aspect ratio of the image and applies it to the container.
 */
function calculateAspectRatio(img, container) {
  const width = img.naturalWidth;
  const height = img.naturalHeight;

  if (width && height) {
    const aspectRatio = (height / width) * 100;
    container.style.paddingBottom = `${aspectRatio}%`;
  }
}

/*
 * Calculate Aspect Ratio
 * Calculates the aspect ratio of the image and applies it to the container.
 */
ready(function() {
  const imageContainers = document.querySelectorAll('.image-banner-asset');

  imageContainers.forEach(container => {
    const images = container.querySelectorAll('[data-calculate-aspect="true"]');

    images.forEach(img => {
      if (img) {
        img.addEventListener('load', function() {
          calculateAspectRatio(img, container);
        });
        if (img.complete) {
          calculateAspectRatio(img, container);
        }
      }
    });
  });
});
  // End of Aspect Ratio calculation.

/*
 * OPTION SELECTOR
 * Works the variant option dropdowns used on the
 * product page template.
 */
ready(function() {
  var variant;
  var options = [];
  options[1] = null;
  options[2] = null;
  options[3] = null;

  var variantOptions = document.querySelectorAll(".js--variant-option");
  variantOptions.forEach(function(el) {
    el.addEventListener("change", function(event) {
      // Disable non-existent variant options.
      checkVariants();

      // Set the chosen options.
      variantOptions.forEach(function(opt) {
        if (opt.tagName.toLowerCase() == 'input' && opt.checked == true) {
          var optionName = opt.getAttribute("name");
          var optionPos = parseInt(optionName.replace("option", ""));
          var optionValue = opt.value;
          options[optionPos] = optionValue;
        }
      });

      // Loop through the variants and get the selected one.
      variants.forEach(function(v) {
        if (v.option1 == options[1] && v.option2 == options[2] && v.option3 == options[3]) {
          variant = v;

          // Update variant id and prices
          document.querySelector("input#js--variant-id").value = v.id;
          
          // Update prices
          document.querySelectorAll(".js--variant-price").forEach(function(el) {
            el.innerHTML = Shopify.formatMoney(v.price);
          });

          if (v.compare_at_price > v.price) {
            document.querySelectorAll(".js--variant-compareatprice").forEach(function(el) {
              el.innerText = Shopify.formatMoney(v.compare_at_price);
            });
          } else {
            document.querySelectorAll(".js--variant-compareatprice").forEach(function(el) {
              el.innerText = "";
            });
          }

          // Update SKU
          document.querySelectorAll('.js--variant-sku').forEach(function(el) {
            el.innerText = variant.sku;
          });

          // Disable the buy button if product is unavailable
          if (v.available === false) {
            document.querySelector("#js--addtocart").disabled = true;
            document.querySelector("#js--addtocart").innerText = "Unavailable";
          } else {
            document.querySelector("#js--addtocart").disabled = false;
            document.querySelector("#js--addtocart").innerText = "Add to cart";
          }

          // Update image
          var imageId = (v.featured_image != null) ? v.featured_image.id : default_image;
          var imageIndex = document
            .querySelector('.product-image-item[data-imageid="' + imageId + '"]')
            .getAttribute("data-index");
          var sliderContainer = document.querySelector(".product-images-component");
          goToImage(imageIndex);

          // Append the variant ID as a url parameter
          if (v != undefined) {
            if (historyState()) {
              window.history.replaceState({}, document.title, "?variant=" + v.id);
            }
          }
        }
      });
    });
  });
});

/*
 * CHECK VARIANT EXISTS
 * This checks if the variant actually exists - e.g you may have small,* medium, and large in blue and black, but blue/medium is not a variant. Disables the
 * related inputs.
 */
function checkVariants() {
  let $this = event.target;
  if ($this !== undefined) {
    let availableVariants = new Set();
    variants.filter(function(variant, k) {
      if (variant[$this.name] == $this.value) {
        availableVariants.add(variant);
      }
    });

    // Loop through the array above to create an array containing available
    // option values.
    let optionGroups = {};
    availableVariants.forEach(function(variant) {
      let options = Object.entries(variant);
      for (const [key, value] of options) {
        if (value != null) {
          if (optionGroups[key] == undefined) {
            optionGroups[key] = [];
          }
          if (optionGroups[key].includes(value) == false) {
            optionGroups[key].push(value);
          }
        }
      }
    });

    // Then, loop through each input and check if its value is in the optionGroups
    // array created above, ignoring the clicked option group.
    document.querySelectorAll(".js--variant-option").forEach(function(input) {
      if (input.name != $this.name) {
        if (optionGroups[input.name].includes(input.value) == false) {
          input.disabled = true;
          input.checked = false;
        } else {
          input.disabled = false;
        }
      }
    });
  }

  // Check a valid option is selected for each group.
  document.querySelectorAll(".js--variant-options").forEach(function(group) {
    let firstAvailable = null;
    let checkedOptions = group.querySelectorAll('.js--variant-option:checked').length;
    if (checkedOptions == 0) {
      firstAvailable = group.querySelectorAll(".js--variant-option:not(:disabled)")[0];
    }
    if (firstAvailable != null) {
      firstAvailable.checked = true;
    }
  });
}

/*
 * TOGGLE MOBILE NAV
 * Open/close main nav on mobile. This just applies a class
 * and the rest is done in CSS.
 */
function toggleNav() {
  let nav = document.querySelector('#header-nav');
  nav.classList.toggle('nav-open');
}

/*
 * ANNOUNCEMENT BAR
 * Handles the sliding functionality of the announcement bar
 */
ready(function() {
  const slider = document.querySelector('.announcement-slider');
  const slides = document.querySelectorAll('.announcement-slide');
  const prevBtn = document.querySelector('.announcement-prev');
  const nextBtn = document.querySelector('.announcement-next');
  let currentSlide = 0;

  if (!slider || slides.length <= 1) return;

  function updateSlider() {
    slider.style.transform = `translateX(-${currentSlide * 100}%)`;
    
    // Update button visibility
    if (prevBtn) {
      prevBtn.style.display = currentSlide === 0 ? 'none' : 'block';
    }
    if (nextBtn) {
      nextBtn.style.display = currentSlide === slides.length - 1 ? 'none' : 'block';
    }
  }

  // Initial button visibility
  updateSlider();

  prevBtn?.addEventListener('click', () => {
    if (currentSlide > 0) {
      currentSlide--;
      updateSlider();
    }
  });

  nextBtn?.addEventListener('click', () => {
    if (currentSlide < slides.length - 1) {
      currentSlide++;
      updateSlider();
    }
  });

  // Auto-advance slides every 5 seconds
  setInterval(() => {
    if (currentSlide < slides.length - 1) {
      currentSlide++;
    } else {
      currentSlide = 0;
    }
    updateSlider();
  }, 5000);
});

/*
 * PRODUCT IMAGE SLIDER
 * Handles the product image slider and thumbnails
 */
ready(function() {
  const galleryLayout = document.querySelector('#product-photos')?.dataset.galleryLayout;
  const isVerticalLayout = galleryLayout === 'vertical';

  // Initialize thumbnail slider first
  const thumbsSlider = new Swiper('.product-thumbs-slider', {
    spaceBetween: 10,
    slidesPerView: 'auto',
    freeMode: true,
    loop: false,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    slideToClickedSlide: true,
    direction: 'horizontal',
    breakpoints: {
      769: {
        direction: isVerticalLayout ? 'vertical' : 'horizontal'
      }
    }
  });

  // Initialize main slider
  const swiper = new Swiper('.product-images-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: thumbsSlider
    }
  });

  // Initialize lightbox functionality
  const lightbox = document.querySelector('.lightbox');
  if (lightbox){
  const lightboxClose = lightbox.querySelector('.lightbox-close');
  const triggers = document.querySelectorAll('.lightbox-trigger');
  let lightboxSwiper;

  // Initialize lightbox Swiper
  lightboxSwiper = new Swiper('.lightbox-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    }
  });

  // Open lightbox from image click
  triggers.forEach((trigger, index) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      lightbox.style.display = 'block';
      document.body.style.overflow = 'hidden';
      lightboxSwiper.slideTo(index, 0);
    });
  });

  // Close lightbox
  lightboxClose.addEventListener('click', () => {
    lightbox.style.display = 'none';
    document.body.style.overflow = '';
  });

  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) {
      lightbox.style.display = 'none';
      document.body.style.overflow = '';
    }
  });

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (lightbox.style.display === 'block') {
      if (e.key === 'Escape') {
        lightbox.style.display = 'none';
        document.body.style.overflow = '';
      }
    }
  });
}
});


// Utility function to jump to image
function goToImage(index) {
  const swiper = document.querySelector('.product-images-slider').swiper;
  if (swiper) {
    if (index === 'next') {
      swiper.slideNext();
    } else if (index === 'prev') {
      swiper.slidePrev();
    } else {
      console.log("Index" + index);
      swiper.slideTo(index, 300);
    }
  }
}

/*
 * QUANTITY CONTROLS
 * Handles the increase/decrease functionality of the quantity selector
 */
ready(function() {
  const quantityControls = document.querySelectorAll('.quantity-controls');
  
  quantityControls.forEach(control => {
    const input = control.querySelector('input[type="number"]');
    const decreaseBtn = control.querySelector('[data-quantity-action="decrease"]');
    const increaseBtn = control.querySelector('[data-quantity-action="increase"]');

    decreaseBtn.addEventListener('click', () => {
      const currentValue = parseInt(input.value);
      if (currentValue > parseInt(input.min)) {
        input.value = currentValue - 1;
      }
    });

    increaseBtn.addEventListener('click', () => {
      const currentValue = parseInt(input.value);
      input.value = currentValue + 1;
    });
  });
});

ready(() => {
  Cart.initialize();
  
  // Add event listener for cart form
  const cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      Cart.handleAddToCart(this);
    });
  }

  // Add event listener for cart drawer button
  const cartDrawerButton = document.querySelector('[data-cart-action="open-drawer"]');
  if (cartDrawerButton) {
    cartDrawerButton.addEventListener('click', function(e) {
      e.preventDefault();
      Cart.openDrawer();
    });
  }

  // Add event listener for closing cart drawer when clicking overlay
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function(e) {
      // Check if the click is on the overlay
      if (e.target.classList.contains('cart-drawer__overlay')) {
        console.log('Overlay clicked');
        Cart.closeDrawer();
      }
    });

    // Prevent clicks inside the drawer from closing it
    const drawerContent = cartDrawer.querySelector('.cart-drawer__wrapper');
    if (drawerContent) {
      drawerContent.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }

    const closeButton = cartDrawer.querySelector('.cart-drawer__close');
    if (closeButton) {
      closeButton.addEventListener('click', Cart.closeDrawer);
    }
  }
});



ready(function() {
  const productGridSwipers = document.querySelectorAll('.products-grid-swiper');
  console.log('Found Swiper elements:', productGridSwipers.length);
  
  productGridSwipers.forEach(swiperEl => {
    const productsPerRow = parseInt(swiperEl.dataset.productsPerRow) || 4;
    const totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;
    console.log('Initializing Swiper with:', { productsPerRow, totalSlides });

    if (totalSlides > 1) {
      try {
        const swiper = new Swiper(swiperEl, {
          slidesPerView: 1.5, // default to mobile view
          spaceBetween: 20,
          navigation: {
            nextEl: swiperEl.querySelector('.swiper-button-next'),
            prevEl: swiperEl.querySelector('.swiper-button-prev'),
          },
          watchOverflow: true,
          resistance: true,
          resistanceRatio: 0.85,
          speed: 500,
          grabCursor: true,
          preventInteractionOnTransition: true,
          observer: true,
          observeParents: true,
          preventClicks: false,              // ← ADD THIS
          preventClicksPropagation: false,   // ← ADD THIS
          breakpoints: {
            480: {
              slidesPerView: 1.5,
              spaceBetween: 10,
            },
            749: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: productsPerRow,
              spaceBetween: 20,
            }
          }
        });
        console.log('Swiper initialized successfully');
      } catch (error) {
        console.error('Error initializing Swiper:', error);
      }
    }
  });
});

// Add to Cart functionality
ready(() => {
  document.addEventListener('submit', function(e) {
    if (e.target.classList.contains('product-card__form')) {
      e.preventDefault();

      const form = e.target;
      const button = form.querySelector('[data-atc-button]');

      if (button && button.disabled) return;

      if (button) {
        button.disabled = true;
        button.dataset.originalText = button.textContent.trim();
        button.innerHTML = 'Adding<span class="atc-dots"><span>.</span><span>.</span><span>.</span></span>';
      }

      Cart.handleAddToCart(form).finally(function() {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || 'Add to Cart';
        }
      });
    }
  });
});

/*
 * LOCALIZATION FORM
 * Handles the currency and language selector updates via AJAX
 */
ready(function() {
  const localizationForm = document.getElementById('localization_form');
  const localizationSelects = document.querySelectorAll('[data-localization-select]');

  if (localizationForm && localizationSelects.length) {
    localizationSelects.forEach(select => {
      select.addEventListener('change', function() {
        const formData = new FormData(localizationForm);
        
        fetch('/localization', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          if (response.ok) {
            window.location.reload();
          } else {
            console.error('Failed to update localization');
          }
        })
        .catch(error => {
          console.error('Error updating localization:', error);
        });
      });
    });
  }
});

/*
 * MOBILE NAV DROPDOWN
 * Handles the mobile nav dropdown functionality
 */
ready(function() {
  function isMobile() {
    return window.innerWidth <= 768;
  }

  if (isMobile()) {
    const dropdownToggles = document.querySelectorAll('.nav__link--dropdown-toggle');

    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const clickedItem = this.closest('.nav__item--dropdown');

        // Close ONLY dropdowns that are NOT ancestors or descendants
        document.querySelectorAll('.nav__item--dropdown.clicked').forEach(openItem => {
          if (!openItem.contains(clickedItem) && !clickedItem.contains(openItem)) {
            openItem.classList.remove('clicked');
          }
        });

        clickedItem.classList.toggle('clicked');
      });
    });

    // Prevent clicks inside any dropdown menu from bubbling up
    document.querySelectorAll('.nav__dropdown-menu').forEach(menu => {
      menu.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    });
  }
});